export async function markMessageAsRead(messageId: string): Promise<boolean> {
  // Try localStorage first, then fallback to sessionStorage if needed (migration support)
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
  const headers: Record<string, string> = {}

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}messages/${messageId}/read`, {
      method: 'PATCH',
      headers,
      credentials: 'include',
    })

    return response.status === 200
  } catch (error) {
    console.error('Error marking message as read:', error)

    return false
  }
}
